import script from "./BillingAddress.vue?vue&type=script&lang=ts&setup=true"
export * from "./BillingAddress.vue?vue&type=script&lang=ts&setup=true"

import "./BillingAddress.vue?vue&type=style&index=0&id=2f0f4980&lang=less"
import "./BillingAddress.vue?vue&type=style&index=1&id=2f0f4980&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0f4980"]])

export default __exports__